export const SYS_DIC_PAGE_SIZE = 20;

export const SYS_DIC_STATUS = {
  DISABLED: 0,
  ENABLED: 1,
};

export const SYS_DIC_STATUS_FILTER_OPTIONS = [
  { value: '', label: '全部' },
  { value: '1', label: '啟用' },
  { value: '0', label: '禁用' },
];

export const SYS_DIC_STATUS_OPTIONS = [
  { value: SYS_DIC_STATUS.ENABLED, label: '啟用' },
  { value: SYS_DIC_STATUS.DISABLED, label: '禁用' },
];

export const EMPTY_SYS_DIC_FILTERS = {
  status: '',
  dicKey: '',
};

export const DEFAULT_SYS_DIC_FORM = {
  dicKey: '',
  dicValue: '',
  remark: '',
  status: SYS_DIC_STATUS.ENABLED,
};

export function buildSysDicPageParams(pageNo, filters, pageSize = SYS_DIC_PAGE_SIZE) {
  const params = {
    pageNo,
    pageSize,
  };
  if (filters.status !== '') {
    params.status = Number(filters.status);
  } else {
    params.status = -1;
  }
  if (filters.dicKey?.trim()) {
    params.dicKey = filters.dicKey.trim();
  }
  return params;
}

export function rowToSysDicForm(row) {
  if (!row) {
    return { ...DEFAULT_SYS_DIC_FORM };
  }
  return {
    dicKey: row.dicKey || '',
    dicValue: row.dicValue || '',
    remark: row.remark || '',
    status: row.status === SYS_DIC_STATUS.DISABLED
      ? SYS_DIC_STATUS.DISABLED
      : SYS_DIC_STATUS.ENABLED,
  };
}

export function formToSysDicPayload(form, id) {
  const payload = {
    dicKey: form.dicKey?.trim() || '',
    dicValue: form.dicValue ?? '',
    remark: form.remark ?? '',
    status: Number(form.status),
  };
  if (id) {
    payload.id = id;
  }
  return payload;
}

export function formatSysDicStatus(status) {
  if (status === SYS_DIC_STATUS.ENABLED) {
    return '啟用';
  }
  if (status === SYS_DIC_STATUS.DISABLED) {
    return '禁用';
  }
  return '—';
}

export function sysDicStatusClassName(status) {
  if (status === SYS_DIC_STATUS.ENABLED) {
    return 'status-text status-text--success';
  }
  if (status === SYS_DIC_STATUS.DISABLED) {
    return 'status-text status-text--danger';
  }
  return 'status-text';
}
